// extracted by mini-css-extract-plugin
module.exports = {"row":"_25rMdWzR col-12 md-col-4 mx-auto flex","icon":"_3YR4bASg"};